import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setUserLogged, setLoading, setCorporationData, setComponentActive } from "../reducers/userConfigSlice";

import { apiRest } from "../api/constants";

import { getCorporationInfo } from "../api/requests";
import { readLoginLS } from "@delibrandev/utils";
import { checkPassword, logIn } from "../api/login";

const Initializer = ({ onInit }) => {
  const dispatch = useDispatch();

  const { componentActive } = useSelector((state) => state.aplicationConfig.userConfig);

  // ✅ Get Coporation Data
  const init = async () => {
    try {
      const [/*productsRes, categoriesRes,*/ corporationRes] = await Promise.all([/*getProducts({}), getCategories({}),*/ getCorporationInfo()]);

      /*  if (productsRes && !productsRes.error) {
        dispatch(updateCorporationProducts(addIdKeyIfMissing(productsRes.data.products)));
      }

      if (categoriesRes && !categoriesRes.error) {
        dispatch(updateCorporationCategories(addIdKeyIfMissing(categoriesRes.data)));
      }*/

      if (corporationRes && !corporationRes.error) {
        dispatch(setCorporationData(corporationRes.data));
      }
    } catch (err) {
      console.error("[init] Error general al inicializar datos:", err);
    }
  };

  // ✅ Get Session Data
  const initSession = async () => {
    try {
      /*const [customerRes] = await Promise.all([getCustomerInfo({})]);

      if (customerRes && !customerRes.error) {
        dispatch(updateCart({ ShoppingCartProducts: [] }));
        dispatch(setUserData(customerRes.data));
      }

      const response = await getCustomerCart();
      if (response && !response.error) dispatch(updateCart(response?.data));*/
    } catch (err) {
      console.error("[initSession] Error general al inicializar datos:", err);
    }
  };

  const autoLogin = async () => {
    const savedLogin = readLoginLS(apiRest);
    if (savedLogin?.password && savedLogin?.login) {
      //Check password platform
      const password = savedLogin.password;
      const responsePassword = await checkPassword({ password });
      if (responsePassword && !responsePassword.error) {
        //Login
        const loginData = savedLogin?.login;
        const response = await logIn(loginData);
        if (response && !response.error) {
          dispatch(setUserLogged(true));
          dispatch(setComponentActive("orders"));
          return true;
        } else {
          dispatch(setUserLogged(false));
          return false;
        }
      } else {
        dispatch(setUserLogged(false));
        return false;
      }
    } else {
      dispatch(setUserLogged(false));
      return false;
    }
  };

  // ✅ Efecto principal de inicialización: control de sesión + carga de datos
  useEffect(() => {
    const initializeApp = async () => {
      console.log("| 🚀 Inicializando aplicación...");
      dispatch(setLoading(true));

      const sessionIsValid = await autoLogin();
      await init();
      if (sessionIsValid) await initSession();

      dispatch(setLoading(false));
      onInit();
    };

    initializeApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ Scroll al cargar cada componente activo
  useEffect(() => {
    document.getElementById("adminBody")?.scrollTo(0, 0);
  }, [componentActive]);

  return null;
};

export default Initializer;
